import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["screenImage", "tab"];

  connect() {
    this.activeSlug = this.tabTargets[0].dataset.slug
    this.updateTabs()
  }

  handleClick(event) {
    this.activeSlug = event.currentTarget.dataset.slug
    this.updateTabs()
  }

  updateTabs() {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("!border-secondary", tab.dataset.slug !== this.activeSlug)
    })
    this.screenImageTargets.forEach(img => {
      if (img.dataset.slug === this.activeSlug) {
        img.classList.remove("opacity-0")
        img.classList.add("opacity-100")
      } else {
        img.classList.remove("opacity-100")
        img.classList.add("opacity-0")
      }
    })
  }
}
